import(/* webpackMode: "eager" */ "/opt/cal-diy/apps/web/app/error.tsx");
